<script>
/**
 * Type         : Page component
 * Title        : 대쉬보드
 * Description  : 화면
 * 
 */

import OrdersWeeklyChart from "@/components/admin/common/chart/OrderWeekly.vue"
import NoticeList from "@/components/admin/common/list/NoticeList.vue"

export default {
  name: 'Page-dashboard',
  meta: {
    title: "어드민 - 관리자 대쉬보드"
  },
  components: {
    OrdersWeeklyChart,
    NoticeList
  },
  computed: {
    labels() {
      return (this.dbData.orderCntInAWeek || []).map(item => item.date);
    },
    series() {
      return (this.dbData.orderCntInAWeek || []).map(item => item.order_count);
    },
    sum(){
      return this.series.reduce((a, b) => a + b, 0);
    },
    weeklyStats() {
      return this.dbData.weeklyStats || this.emptyComparison();
    },
    monthlyStats() {
      return this.dbData.monthlyStats || this.emptyComparison();
    },
    partnerStats() {
      return (this.dbData.partnerStats || []).map(item => ({
        ...item,
        weekly_received: Number(item.weekly_received || 0),
        weekly_completed: Number(item.weekly_completed || 0),
        monthly_received: Number(item.monthly_received || 0),
        monthly_completed: Number(item.monthly_completed || 0),
        weekly_completion_rate: Number(item.weekly_received || 0) > 0
          ? Number(((Number(item.weekly_completed || 0) / Number(item.weekly_received || 0)) * 100).toFixed(1))
          : null,
        monthly_completion_rate: Number(item.monthly_received || 0) > 0
          ? Number(((Number(item.monthly_completed || 0) / Number(item.monthly_received || 0)) * 100).toFixed(1))
          : null,
        weekly_avg_processing_days: item.weekly_avg_processing_days === null ? null : Number(item.weekly_avg_processing_days || 0),
        monthly_avg_processing_days: item.monthly_avg_processing_days === null ? null : Number(item.monthly_avg_processing_days || 0),
        delayed_count: Number(item.delayed_count || 0),
        stalled_count: Number(item.stalled_count || 0),
      }))
    }
  },
  data() {
    return {
      description   : {
        title : '대쉬보드'
      },
      dbData : {
        orderCnt        : 0,
        orderCntInAWeek : [],
        statusCnt       : [],
        newCustomerCnt  : 0,
        hsCodeCandidateSummary: null,
        weeklyStats: null,
        monthlyStats: null,
        partnerStats: [],
      },

      loadingDashboard: false,
      dashboardError: false,
      alertPolicyDialog: false,
      alertPolicyLoading: false,
      alertPolicies: [],
      alertPolicyForm: { partnerId: 0, stalledDays: 7, delayedDays: 30 },

      noticeListAdmin    : [],
      currPageAdmin      : 0,
      noticeListCustomer : [],
      currPageCustomer   : 0,

      authLevel   : 0,

      // 검색조건
      partnerId         : null,
      proxyDate         : {},
      hblNo             : "",

      // receiver          : "",
      // regId             : this.$store.getters.getLocalSession.id,
      // mobileCountry     : "",
      // mobileNum         : "",
      // customerEmail     : "",
      // courierCode       : "",
      // courierNum        : "",
      // customerId        : "",
      // orderNum          : "", // 주문번호
      // mblNo             : "",
      // statusCode        : [], // 오더 상태 코드 목록
      // filteredLocation  : [],
      // shippingMethod    : [],
    }
  },


  methods:{
    emptyComparison() {
      return {
        current: { received: 0, completed: 0, delayed: 0, stalled: 0 },
        previous: { received: 0, completed: 0, delayed: 0, stalled: 0 },
        receivedRate: 0,
        completedRate: 0,
        delayedRate: 0,
      }
    },
    formatRate(rate) {
      if (rate === null) return '비교 기준 없음'
      return `${rate > 0 ? '+' : ''}${rate}%`
    },
    rateColor(rate) {
      if (rate === null || rate === 0) return 'text-grey-7'
      return rate > 0 ? 'text-positive' : 'text-negative'
    },
    goToDashboardOrders(view, options = {}) {
      const query = { view, ...options }
      if (this.partnerId) query.partnerId = this.partnerId
      this.$router.push({ name: 'Admin-dashboard-orders', query })
    },
    goToStatusOrders(status) {
      this.goToDashboardOrders('status', { status })
    },
    goToDailyReceivedOrders(date) {
      this.goToDashboardOrders('received', { period: 'daily', date })
    },
    goToPartnerOrders(row) {
      if (!row?.partner_id) return
      this.goToDashboardOrders('received', { period: 'monthly', comparison: 'current', partnerId: row.partner_id })
    },
    async loadAlertPolicies() {
      this.alertPolicyLoading = true
      try {
        const res = await this.$http({ method: 'GET', url: '/api/dashboard/alert-policies', name: '[ Axios / 운영 경고 기준 조회 ]' })
        this.alertPolicies = res?.data?.items || []
        this.applyAlertPolicy(this.alertPolicyForm.partnerId)
      } catch (err) {
        this.$log.error('[ 운영 경고 기준 조회 ]', err)
        this.$q.notify({ type: 'negative', message: '운영 경고 기준을 불러오지 못했습니다.', position: 'top' })
      } finally {
        this.alertPolicyLoading = false
      }
    },
    applyAlertPolicy(partnerId) {
      const policy = this.alertPolicies.find(item => Number(item.partner_id) === Number(partnerId))
        || this.alertPolicies.find(item => Number(item.partner_id) === 0)
        || { stalled_days: 7, delayed_days: 30 }
      this.alertPolicyForm.stalledDays = Number(policy.stalled_days)
      this.alertPolicyForm.delayedDays = Number(policy.delayed_days)
    },
    async openAlertPolicyDialog() {
      this.alertPolicyDialog = true
      await this.loadAlertPolicies()
    },
    async saveAlertPolicy() {
      this.alertPolicyLoading = true
      try {
        await this.$http({
          method: 'PUT',
          url: `/api/dashboard/alert-policies/${this.alertPolicyForm.partnerId}`,
          data: { stalledDays: Number(this.alertPolicyForm.stalledDays), delayedDays: Number(this.alertPolicyForm.delayedDays) },
          name: '[ Axios / 운영 경고 기준 저장 ]'
        })
        this.$q.notify({ type: 'positive', message: '운영 경고 기준을 저장했습니다.', position: 'top' })
        await this.loadAlertPolicies()
        await this.loadDashboard()
      } catch (err) {
        this.$log.error('[ 운영 경고 기준 저장 ]', err)
        this.$q.notify({ type: 'negative', message: err?.response?.data || '운영 경고 기준 저장에 실패했습니다.', position: 'top' })
      } finally {
        this.alertPolicyLoading = false
      }
    },
    /**
     * Title        : 대쉬보드 데이터 조회
     * Status       : Actived
     * Payload      : { 
     *                  authLv : 권한 
     *                  , partnerId : 파트너 ID
     *                  , proxyDate : { from : 시작일, to : 종료일 }
     *                }
     * Description  : -
     */
    async loadDashboard() {

      this.loadingDashboard = true
      this.dashboardError = false

      let payload = {
        authLv    : this.authLevel,
        partnerId : this.partnerId,
        proxyDate : this.proxyDate
      }

      this.$log.debug("payload = ", payload)

      let config = {
        method  : "POST",
        url     : "/api/dashboard/",
        data    : payload,
        name    : "[ Axios / 대쉬보드 / 기본 설정 호출 ]"
      }

      await this.$http(config)
        .then(res => {
          this.$log.debug("불러오기 성공", res.data)

          // Response data 를 data 에 넣는다.
          this.dbData = res.data

        })
        .catch((err) => {
          this.$log.debug("/api/dashboard/", err)
          this.dashboardError = true
        })
        .finally(() => {
          this.loadingDashboard = false
      })
    },

    /**
     * Title : 공지사항목록조회
     * Description  : 공지사항 목록을 불러온다.
     * - 관리자의 경우 전체 공지사항을 불러온다.
     * - 파트너의 경우 파트너 공지사항만 불러온다.
     * @param {*} curr : 현재 페이지 번호
     * @param {*} brdTyp : 공지사항 타입 (1: 고객 공지 , 2: 관리자/파트너 공지)
     */
    async loadNoticeList(curr, brdTyp) {
      let payload = {
        paging : curr,
        brdTyp : brdTyp,  // 1: 고객 공지 , 2: 관리자/파트너 공지
      }

      let config = {
        method  : "POST",
        url     : "/api/board/getNoticeList",
        data    : payload,
        name    : "[ Axios / 공지사항목록조회 ]"
      }

      await this.$http(config)
        .then(res => {
          this.$log.debug(res.data)

          const result = res?.data?.items

          if(result.length === 0 || result.length === undefined ){
            this.$q.notify({
              type: 'positive',
              message: '더 불러올 공지글이 없습니다.',
              position: 'top',
              timeout: 3000,
            })
          } else {
            let newNoticeList = result
            newNoticeList.map(item => {

              if(brdTyp === '2')
                this.noticeListAdmin.push(item)
              else if(brdTyp === '1')
                this.noticeListCustomer.push(item)
            })
          }
        })
        .catch((err) => {
          this.$log.debug(err)
          this.$q.notify({
            type: 'negative',
            message: '공지글 불러오기에 실패했습니다.',
            position: 'top',
            timeout: 3000,
          })
      })
    },


    /**
     * Title        : 검색 조건에 따른 화물검색을 실행
     * Status       : Actived
     * Description  : 검색 조건에 따른 화물검색 기능 실행
     *                검색조건은 ParcelLookupForm 컴포넌트에서 동기화된다.
     *                통합조회 화면으로 이동하여 검색조건에 맞는 화물을 조회한다.
     * @param (idx)  : 선택된 배송상품의 idx
     */
    lookupParcel() {
      this.$router.push({
        name: 'Admin-parcel-infomation',
        query: {
          departure       : 'dashboard',
          hblNo           : this.hblNo,   // 대쉬보드에서는 H B/L No. 만 검색조건으로 전달
          // receiver          : this.receiver,
          // regId             : this.regId,
          // mobileCountry     : this.mobileCountry,
          // mobileNum         : this.mobileNum,
          // customerEmail     : this.customerEmail,
          // courierCode       : this.courierCode,
          // courierNum        : this.courierNum,
          // customerId        : this.customerId,
          // orderNum          : this.orderNum,
          // mblNo             : this.mblNo,
          // statusCode        : this.statusCode.join(','),
          // filteredLocation  : this.filteredLocation.join(','),
          // shippingMethod    : this.shippingMethod.join(','),
          // proxyDate         : JSON.stringify(this.proxyDate)
        }
      })
    },

    goHsCodeManage() {
      this.$router.push({
        path: '/admin/hs-code-manage',
        query: { tab: 'candidates' }
      })
    },


    /**
     * Title        : 숫자 0 Left padding
     * Status       : Actived
     * Description  : 숫자 앞에 0을 채워서 길이를 맞춘다.
     * @param {Number} num - 숫자
     * @param {Number} length - 길이
     */
    lPad(num, length) {
      this.$log.debug("[ Parcel lookup form / lPad ] num = ", num, ", length = ", length)

      // 숫자를 문자열로 변환하고, 길이가 length보다 작으면 앞에 0을 채운다.
      return String(num).padStart(length, '0')
    },


    /**
     * Title        : 캘린더 default 설정
     * Status       : Actived
     * Description  : 오늘 날짜 획득
     */
    getToday(){
      let today = new Date().toDateString()

      let newToday = new Date(today)

      let year  = newToday.getFullYear()    // 년
      let month = newToday.getMonth() + 1   // 월
      let day   = newToday.getDate()        // 일
      
      let result = year + "-" + this.lPad(month, 2) + "-" + this.lPad(day, 2)

      this.$log.debug("[ Parcel lookup form / getToday ] = ", result)

      return result
    },


    /**
     * Title        : 캘린더 default 설정
     * Status       : Actived
     * Description  : 일주일전 날짜 획득
     */
    getAWeekAgo(){
      let today = new Date().toDateString()

      let newToday = new Date(today)

      let year  = newToday.getFullYear()    // 년
      let month = newToday.getMonth() + 1   // 월
      let day   = newToday.getDate()        // 일

      let aWeekAgo = new Date(new Date().setDate(day - 7))

      let newAWeekAgo = new Date(aWeekAgo)

      year  = newAWeekAgo.getFullYear() // 년
      month = newAWeekAgo.getMonth() + 1  // 월
      day   = newAWeekAgo.getDate()      // 일

      let result = year + "-" + this.lPad(month, 2) + "-" + this.lPad(day, 2)

      this.$log.debug("[ Parcel lookup form / getAWeekAgo ] = ", result)

      return result
    },


    /**
     * Title        : 캘린더 default 설정
     * Status       : Actived
     * Description  : 캘린더의 일자를 기본설정으로 돌린다.
     */
    async initCalendar(){
      this.$log.debug("[ Parcel lookup form / initCalendar ]")

      const aWeekAgo  = this.getAWeekAgo()
      const today     = this.getToday()
      
      this.datepicker  = { 
        from  : aWeekAgo,
        to    : today
      }

      this.proxyDate   = { 
        from  : aWeekAgo,
        to    : today
      }
    },


    /** 
     * 공지사항 수정
     */
    callModalEditNotice(selected){
      this.noticeModal    = true
      this.editorMode     = 1
      this.noticeData     = selected

      this.$log.debug("Edit notice executed => noticeModal : " + this.noticeModal + ", editorMode : " + this.editorMode)
      this.$log.debug("noticeData => ", selected)
    },


    /**
     * Title        : 초기화
     * Status       : Actived
     * Description  : 공통코드, 파트너 목록등을 불러온다.
     * 
     * 관리자
     * - 권한 목록 조회
     * - 공통 코드 조회
     * - 파트너 목록 조회
     * - 전체 공지 글 조회
     * 
     * 파트너
     * - 권한 목록 조회
     * - 1주일간 등록된 오더 현황 조회
     * - 공지 글 조회
     */
    async init(){
      this.$log.info("[ Dashboard ] init() called")

      // 권한 레벨 설정
      this.authLevel =  this.$getAuthLevel()

      // 배송상품조회
      await this.initCalendar()

      // 대쉬보드 데이터 조회
      await this.loadDashboard()

      // 공지사항 목록 초기화
      this.noticeListAdmin = []
      await this.loadNoticeList(0, '2')  // 공지사항 - 관리자
      
      // 관리자인 경우에만 파트너 목록을 불러온다.
      if(Number(this.authLevel) >= 90){
        this.$getPartnerList()

        this.noticeListCustomer = []
        await this.loadNoticeList(0, '1')  // 공지사항 - 고객 
      }
    }
  },
  mounted() {
    this.$log.info("[ Dashboard ] mounted")

    this.init()
  },
}
</script>

<template>
  <q-page class="q-pa-lg dashboard-page">

    <!-- S: Search Bar -->
    <div class="row q-py-md q-mb-md dashboard-toolbar items-center">
      <div class="col-12 col-md text-h5 text-weight-bold q-mb-sm q-mb-md-none">운영 대시보드</div>
      <div class="col-12 col-md-auto flex justify-end items-center">
        <q-input
          class="bar-search"
          v-model="hblNo" 
          outlined
          rounded
          label="H/BL No.">
          <template v-slot:append>
            <q-btn 
              round 
              color="primary" 
              icon="search"
              @click="lookupParcel" />
          </template>
        </q-input>
        <q-btn 
          class="btn-refresh q-ml-md"
          round 
          size="md"
          color="secondary" 
          icon="refresh"
          @click="init()" />
        <q-btn v-if="Number(authLevel) >= 90" class="q-ml-sm" outline color="secondary" icon="tune" label="운영 경고 기준" @click="openAlertPolicyDialog" />
      </div>
    </div>
    <!-- E: Search Bar -->

    <div
      v-if="Number(authLevel) >= 90 && dbData.hsCodeCandidateSummary && (dbData.hsCodeCandidateSummary.pending || dbData.hsCodeCandidateSummary.needsReview || dbData.hsCodeCandidateSummary.lastRun?.status === 'failed')"
      class="comp-box q-mb-md q-pa-md hs-code-alert dashboard-alert">
      <div class="row items-center justify-between q-col-gutter-md">
        <div class="col-12 col-md">
          <div class="text-subtitle1 text-weight-bold">
            검토해야 할 HS CODE 매핑 후보가 있습니다.
            <q-badge
              v-if="dbData.hsCodeCandidateSummary.lastRun?.status === 'failed'"
              color="negative"
              class="q-ml-sm">
              최근 추출 실패
            </q-badge>
          </div>
          <div class="text-caption text-grey-7">
            검토 대기 {{ dbData.hsCodeCandidateSummary.pending }}건,
            검수 필요 {{ dbData.hsCodeCandidateSummary.needsReview }}건,
            등록 완료 {{ dbData.hsCodeCandidateSummary.mapped }}건,
            제외 {{ dbData.hsCodeCandidateSummary.ignored }}건
            <span v-if="dbData.hsCodeCandidateSummary.lastRun?.finishedAt">
              · 마지막 추출 {{ dbData.hsCodeCandidateSummary.lastRun.finishedAt }}
            </span>
            <span v-if="dbData.hsCodeCandidateSummary.lastRun?.message">
              · {{ dbData.hsCodeCandidateSummary.lastRun.message }}
            </span>
          </div>
        </div>
        <div class="col-12 col-md-auto">
          <q-btn
            color="primary"
            unelevated
            icon="arrow_forward"
            label="HS CODE 관리로 이동"
            @click="goHsCodeManage" />
        </div>
      </div>
    </div>

    <div v-if="loadingDashboard" class="row justify-center q-py-xl">
      <q-spinner color="primary" size="36px" />
    </div>

    <div v-else-if="dashboardError" class="comp-box q-pa-md text-negative">
      대시보드 통계를 불러오지 못했습니다. 새로고침 후 다시 시도해 주세요.
    </div>

    <!-- S: Dashboard Content -->
    <div v-else class="row items-stretch q-col-gutter-md dashboard-content">
      <div class="col-12">
        <div class="section-title">핵심 통계 및 운영 경고</div>
        <div class="row q-col-gutter-md items-stretch">
          <div class="col-12 col-sm-6 col-lg-3">
            <div class="comp-box dashboard-summary dashboard-summary--action q-pa-md" @click="goToDashboardOrders('received', { period: 'weekly', comparison: 'current' })">
              <div class="text-caption text-grey-7">이번 주 오더접수</div>
              <div class="count">{{ weeklyStats.current.received }}건</div>
              <div class="text-caption" :class="rateColor(weeklyStats.receivedRate)">
                전주 동기 {{ weeklyStats.previous.received }}건 · {{ formatRate(weeklyStats.receivedRate) }}
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <div class="comp-box dashboard-summary dashboard-summary--action q-pa-md" @click="goToDashboardOrders('completed', { period: 'weekly', comparison: 'current' })">
              <div class="text-caption text-grey-7">이번 주 수령완료</div>
              <div class="count">{{ weeklyStats.current.completed }}건</div>
              <div class="text-caption" :class="rateColor(weeklyStats.completedRate)">
                전주 동기 {{ weeklyStats.previous.completed }}건 · {{ formatRate(weeklyStats.completedRate) }}
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <div class="comp-box dashboard-summary dashboard-summary--action q-pa-md" @click="goToDashboardOrders('received', { period: 'monthly', comparison: 'current' })">
              <div class="text-caption text-grey-7">이번 달 오더접수</div>
              <div class="count">{{ monthlyStats.current.received }}건</div>
              <div class="text-caption" :class="rateColor(monthlyStats.receivedRate)">
                전월 동기 {{ monthlyStats.previous.received }}건 · {{ formatRate(monthlyStats.receivedRate) }}
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <div class="comp-box dashboard-summary dashboard-summary--action q-pa-md" @click="goToDashboardOrders('completed', { period: 'monthly', comparison: 'current' })">
              <div class="text-caption text-grey-7">이번 달 수령완료</div>
              <div class="count">{{ monthlyStats.current.completed }}건</div>
              <div class="text-caption" :class="rateColor(monthlyStats.completedRate)">
                전월 동기 {{ monthlyStats.previous.completed }}건 · {{ formatRate(monthlyStats.completedRate) }}
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <div class="comp-box dashboard-summary dashboard-summary--action q-pa-md" @click="goToDashboardOrders('delayed')">
              <div class="text-caption text-grey-7">현재 지연 화물</div>
              <div class="count" :class="weeklyStats.current.delayed > 0 ? 'text-negative' : ''">{{ weeklyStats.current.delayed }}건</div>
              <div class="text-caption text-grey-7">오더접수 후 30일 이상 · 수령완료 제외</div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <div class="comp-box dashboard-summary dashboard-summary--action q-pa-md" @click="goToDashboardOrders('stalled')">
              <div class="text-caption text-grey-7">상태 정체 화물</div>
              <div class="count" :class="weeklyStats.current.stalled > 0 ? 'text-warning' : ''">{{ weeklyStats.current.stalled }}건</div>
              <div class="text-caption text-grey-7">최근 상태 변경 후 7일 이상 · 수령완료 제외</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col col-12 col-md-6">
        <div class="comp-box row dashboard-panel">
          <div class="col-8">
            <h3 class="title">최근 7일 오더접수 추이</h3>
          </div>
          <div class="col-4">
            <q-select
              v-if="Number(authLevel) >= 90"
              v-model="partnerId"
              :options="[{label: '전체', value: null}, ...$store.getters.getPartnerList]"
              @update:model-value="loadDashboard"
              label="파트너 선택"
              outlined
              dense
              emit-value
              map-options />
          </div>

          <div class="col-9 col-xs-12 col-sm-9">
            <div class="count">
              <OrdersWeeklyChart 
                :labels="labels"
                :series="series"
                @select-date="goToDailyReceivedOrders" />
            </div>
          </div>

          <div class="col-3 col-xs-12 col-sm-3 text-right">
            <h3 class="title q-mb-xs">이번 주 오더접수</h3>
            <div class="count q-mb-lg">
              {{ weeklyStats.current.received }}
            </div>

            <h3 class="title q-mb-xs">이번 주 수령완료</h3>
            <div class="count">
              {{ weeklyStats.current.completed }}
            </div>
          </div>

        </div>
      </div>


      <div class="col col-12 col-md-6">
        <div class="comp-box row dashboard-panel">
          <h3 class="title col-12">현재 오더 상태별 현황</h3>
          <div 
            class="col col-2 col-xs-6 col-md-4 col-lg-2 text-center"
            v-for="s in dbData.statusCnt"
            :key="s.status">  
            <q-card 
              flat 
              class="my-card cursor-pointer"
              @click="goToStatusOrders(s.status)">
              <q-card-section
                :class="(s.count === 0 ? ' text-grey' : '')">
                <div class="title">{{ s.status_name }}</div>
                <div class="count">
                  {{ s.count }} 건
                </div>
              </q-card-section>

            </q-card>
          </div>
        </div>
        <!--
        <div class="comp-box">
          <h3 class="title">오늘 신규등록 고객</h3>
          <div class="count">
            {{ dbData.newCustomerCnt }}
          </div>
        </div>
        -->
      </div>


      <div v-if="Number(authLevel) >= 90" class="col-12">
        <div class="comp-box dashboard-partner-panel q-pa-md">
          <h3 class="title q-mb-md">파트너별 운영 비교</h3>
          <div class="partner-table-scroll"><q-table
            flat
            dense
            row-key="partner_id"
            :rows="partnerStats"
            :columns="[
              { name: 'partner_name', label: '파트너', field: row => row.partner_name || `#${row.partner_id}`, align: 'left' },
              { name: 'weekly_received', label: '이번 주 접수', field: 'weekly_received', align: 'right' },
              { name: 'weekly_completed', label: '이번 주 완료', field: 'weekly_completed', align: 'right' },
              { name: 'weekly_completion_rate', label: '이번 주 완료율', field: row => row.weekly_completion_rate === null ? '-' : `${row.weekly_completion_rate}%`, align: 'right' },
              { name: 'weekly_avg_processing_days', label: '이번 주 평균 처리일', field: row => row.weekly_avg_processing_days === null ? '-' : `${row.weekly_avg_processing_days}일`, align: 'right' },
              { name: 'monthly_received', label: '이번 달 접수', field: 'monthly_received', align: 'right' },
              { name: 'monthly_completed', label: '이번 달 완료', field: 'monthly_completed', align: 'right' },
              { name: 'monthly_completion_rate', label: '이번 달 완료율', field: row => row.monthly_completion_rate === null ? '-' : `${row.monthly_completion_rate}%`, align: 'right' },
              { name: 'monthly_avg_processing_days', label: '이번 달 평균 처리일', field: row => row.monthly_avg_processing_days === null ? '-' : `${row.monthly_avg_processing_days}일`, align: 'right' },
              { name: 'delayed_count', label: '지연', field: 'delayed_count', align: 'right' },
              { name: 'stalled_count', label: '상태 정체', field: 'stalled_count', align: 'right' },
            ]"
            :pagination="{ rowsPerPage: 10 }"
            no-data-label="비교할 파트너 데이터가 없습니다."
            class="cursor-pointer"
            @row-click="(_, row) => goToPartnerOrders(row)"
          /></div>
          <div class="text-caption text-grey-7 q-mt-sm">완료율은 해당 기간 접수 주문 중 현재 수령완료 비율이며, 평균 처리일은 해당 기간 수령완료된 주문의 오더접수부터 수령완료까지 평균입니다. 행을 클릭하면 해당 파트너의 이번 달 오더접수 목록으로 이동합니다.</div>
        </div>
      </div>

      <div class="col col-12 col-md-6">
        <div class="comp-box row dashboard-panel">
          <div class="col-12">
            <h3 class="title">공지사항 - 관리자</h3>
            <NoticeList
              :notice-list="noticeListAdmin"
              @reload-parcel-list="loadNoticeList(0, '2')"
              @load-more-list="loadNoticeList(currPageAdmin + 1, '2')"
              @edit-modal="callModalEditNotice" />
          </div>
        </div>
      </div>
  
      <div
        v-if="(Number(this.authLevel) >= 90)"
        class="col col-12 col-md-6">
        <div class="comp-box row">
          <div class="col-12">
            <h3 class="title">공지사항 - 고객</h3>
          </div>
          <div class="col-12">
            <NoticeList
              :notice-list="noticeListCustomer"
              @reload-parcel-list="loadNoticeList(0, '1')"
              @load-more-list="loadNoticeList(currPageAdmin + 1, '1')"
              @edit-modal="callModalEditNotice" />
          </div>
        </div>
      </div>
    </div>
    <!-- E: Dashboard Content  -->

    <q-dialog v-model="alertPolicyDialog">
      <q-card style="width: 480px; max-width: 95vw;">
        <q-card-section><div class="text-h6">운영 경고 기준</div><div class="text-caption text-grey-7">파트너 예외가 없으면 공통 기준이 적용됩니다.</div></q-card-section>
        <q-card-section class="q-gutter-md">
          <q-select v-model="alertPolicyForm.partnerId" :options="[{ label: '공통 기준', value: 0 }, ...$store.getters.getPartnerList]" emit-value map-options outlined label="적용 대상" @update:model-value="applyAlertPolicy" />
          <q-input v-model.number="alertPolicyForm.stalledDays" type="number" min="1" max="365" outlined label="상태 정체 기준(일)" />
          <q-input v-model.number="alertPolicyForm.delayedDays" type="number" min="1" max="365" outlined label="지연 기준(일)" />
        </q-card-section>
        <q-card-actions align="right"><q-btn flat label="닫기" v-close-popup /><q-btn color="primary" label="저장" :loading="alertPolicyLoading" @click="saveAlertPolicy" /></q-card-actions>
      </q-card>
    </q-dialog>

  </q-page>

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.bar-search {
  max-width: 400px;
  min-width: 280px;
}
.dashboard-page {
  max-width: 1680px;
  margin: 0 auto;
}
.dashboard-toolbar {
  border-bottom: 1px solid #e7e9ed;
  padding-bottom: 16px;
}
.section-title {
  font-size: 1rem;
  font-weight: 700;
  margin: 0 0 10px 4px;
  color: #3d4652;
}
.comp-box {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  height: -webkit-fill-available;
  margin-left: 0;
  margin-right: 0;
  border: 1px solid #edf0f3;
  border-radius: 10px;
  background: #fff;

  .title {
    font-size: 1rem;
    margin-top: 0;
    line-height: inherit;
  }

  .count {
    font-size: 1.4rem;
  }
}

.btn-refresh {
  height: fit-content;
}

.dashboard-summary {
  height: 100%;
  min-height: 122px;
  transition: box-shadow .15s ease, transform .15s ease;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-rows: auto 1fr auto;
  align-items: start;
}
.dashboard-summary > :first-child {
  grid-column: 1;
  grid-row: 1;
  font-size: 1rem;
  font-weight: 700;
  color: #303947;
}
.dashboard-summary > :nth-child(2) {
  grid-column: 2;
  grid-row: 1;
  font-size: 1.7rem;
  font-weight: 700;
  line-height: 1.1;
  text-align: right;
}
.dashboard-summary > :nth-child(3) {
  grid-column: 1 / -1;
  grid-row: 3;
  width: 100%;
  text-align: right;
}

.dashboard-summary--action {
  cursor: pointer;
}
.dashboard-summary--action:hover {
  box-shadow: 0 5px 16px rgba(30, 60, 90, .12);
  transform: translateY(-1px);
}

.dashboard-partner-panel {
  height: auto;
  display: block;
}
.dashboard-panel {
  padding: 20px;
}
.dashboard-alert {
  height: auto;
  border-left: 4px solid #f2a31a;
}
.partner-table-scroll {
  overflow-x: auto;
}

</style>
